import * as types from 'constants/action_types'

export function doClearLabelSearch() {
  return dispatch => {
    dispatch({ type: types.CLEAR_LABEL_SEARCH_TERM })
  }
}
